import AsyncStorage from '@react-native-async-storage/async-storage';
import { StackActions } from '@react-navigation/native';
import * as Device from 'expo-device';
import * as React from 'react';
import { useState } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { Button, TextInput } from 'react-native-paper';
import { NavigationRoute, NavigationScreenProp } from "react-navigation";
import { useMutation } from "react-query";
import { login } from "../services/ApiService";



export interface ILoginScreenProps {
    navigation: NavigationScreenProp<NavigationRoute>;
}

interface FormData {
    username: string;
    password: string;
    device: string;
}

export function LoginScreen({ navigation }: ILoginScreenProps) {
    const [formData, setFormData] = useState<FormData>({
        username: '',
        password: '',
        device: Device.deviceName ?? 'Unknown Device',
    });
    const [secure, setSecure] = useState(true);
    const version = 0.1;

    const { mutate, data, isLoading, isError, error } = useMutation(() => login(formData), {
    });

    React.useEffect(() => {
        if (isError) {
            console.log({ error, data });
            alert(error?.response?.data?.message);
        }
    }, [isError]);


    React.useEffect(() => {
        if (data && data.token) {
            AsyncStorage.setItem('token', data.token).then(() => {
                navigation.dispatch(StackActions.replace('Home'));
            });
        }
    }, [data]);

    return (
        <View style={styles.container}>
            <Image source={require('../../assets/icon.png')} style={styles.image} />
            <TextInput
                label="Username"
                value={formData.username}
                onChangeText={(text) => setFormData({ ...formData, username: text })}
                style={styles.textInput}
            />
            <TextInput
                label="Password"
                value={formData.password}
                onChangeText={(text) => setFormData({ ...formData, password: text })}
                style={styles.textInput}
                secureTextEntry={secure}
                right={<TextInput.Icon icon={secure ? 'eye' : 'eye-off'} onPress={() => setSecure(!secure)} />}
            />
            <Button
                mode="contained"
                onPress={() => mutate()}
                disabled={isLoading}>
                {isLoading ? 'Hemm....' : 'Masuk Bre'}
            </Button>
        </View>
    );
}

const styles = StyleSheet.create({
    image: {
        width: 100,
        height: 100,
        alignSelf: 'center',
        marginBottom: 50,
    },
    container: {
        position: 'relative',
        flex: 1,
        justifyContent: 'center',
        padding: 10,
        gap: 10,
    },
    textInput: {
        marginBottom: 10,
    },
    appVersion: {
        position: 'absolute',
        bottom: 0,
        alignContent: 'center',
        justifyContent: 'center',
        padding: 10
    }
});

